import React, { Component } from "react";
import Input from "../levty-ui/input";

import { setCarrersAccessToken, getCarrersAuthentication } from "../../utils/authentication";
import { hasAllKeysTrue } from "../../utils/objects";
import LoadingButton from "../levty-ui/loadingButton";
import contactService from "../../services/contactService";

class CarrerEmailTokenModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputs: {
        validations: {
          emailToken: false
        },
        values: {
          emailToken: "",

        }
      },
      allInputsValid: false,
      backendError: false
    }
  }

  setInputData = (input, validation, value) => {
    const { inputs } = this.state;
    inputs.validations[input] = validation;
    inputs.values[input] = value;

    this.setState({ inputs });
    this.validateForm();
  }

  validateForm() {
    const { inputs } = this.state;
    this.setState({ allInputsValid: hasAllKeysTrue(inputs.validations) });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const { handleClose, handleEmailTokenModal } = this.props;
      let { inputs } = this.state;
      let sessionStorageData = getCarrersAuthentication();

      this.setState({ backendError: false });

      inputs.values.name = sessionStorageData.name;
      inputs.values.email = sessionStorageData.email;
      inputs.values.contactReason = "application";

      this.setState({ isLoading: true });
      const result = await contactService.validatesRegistration(inputs.values);
      if (result) {
        setCarrersAccessToken(result.accessToken);
        this.setState({ isLoading: false });
        handleClose();
        handleEmailTokenModal(false);
      } else {
        this.setState({ isLoading: false, backendError: true });
      }
    } catch {
      this.setState({ isLoading: false, backendError: true });
    }
  }

  handleClickBack = () => {
    const { handleEmailTokenModal } = this.props;
    handleEmailTokenModal(false);
  }

  handleClose = () => {
    const { handleClose } = this.props;
    handleClose();
  }

  render() {
    const { allInputsValid, isLoading, inputs, backendError } = this.state;

    return (
      <>
        <div   translate="no" className="notranslate modal fade show animated fadeInDown fast" id="levDadosAcesso" style={{ "display": "block" }}>
          <div   translate="no" className="notranslate modal-dialog" role="document">
            <div   translate="no" className="notranslate modal-content">
              <div   translate="no" className="notranslate modal-header text-center align-items-center flex-column p-0">
                <h5 className="notranslate h2 modal-title" id="exampleModalLabel2">Confira seu email</h5>
                <p   translate="no" className="notranslate mb-4 pb-2">Insira o código de acesso que enviamos para sua caixa de entrada para confirmar seu email.</p>
                <button type="button" className="notranslate close" data-dismiss="modal" aria-label="Close" onClick={this.handleClose}>
                  <span   translate="no" aria-hidden="true">&times;</span>
                </button>
              </div>
              <div   translate="no" className="notranslate modal-body">
                <form id="carrer-token" onSubmit={this.handleSubmit}>
                  <div   translate="no" className="notranslate mb-3">
                    <Input
                      id="emailToken"
                      label="Código de acesso"
                      type="text"
                      aditionalClass="form-control-lg"
                      validationErrorMessage="Código de verificação inválido"
                      required={true}
                      readOnly={false}
                      callBackFunction={this.setInputData}
                      value={inputs.values.emailToken}
                      backEndvalidationError={backendError}
                    />
                  </div>
                  <LoadingButton
                    label="Continuar"
                    aditionalClass="primary mb-2"
                    onlyDisable={!allInputsValid}
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LoadingButton
                    label="Voltar"
                    aditionalClass="link"
                    onClick={this.handleClickBack}
                    type="button"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
        <div   translate="no" className="notranslate modal-backdrop fade show"></div>
      </>
    )
  }
}
export default CarrerEmailTokenModal;
